import type { SensorViewValues } from '../models/sensorViewValues';

export type Value = {
  name: string;
  value: number;
  unit: string;
}

/**
 * Validate an email address
 */
export const validateEmail = (input: string): boolean =>
  /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(input);

/**
 * Convert sensor view value to value
 */
export const convertValue = (
  viewValue: SensorViewValues['values'][number] | undefined
): Value | undefined =>
  viewValue
    ? {
      name: viewValue.name || '',
      unit: viewValue.unit || '',
      value: viewValue.value as number
    }
    : undefined;

export const extractMeta = (
  view: SensorViewValues
) => ({
  name: view.name,
  location: view.address,
  updated: new Date(view.updated),
  serial: view.serial
});
